export default {
  DEFAULT_STATE_FILTER: state => state.defaultFilters.state,
};
